import React, { useState, useImperativeHandle, useRef } from 'react';
import { Upload } from './universe';
import { Button, Input,MessagePlugin,Tooltip } from 'tdesign-react';
import { isLogin } from '../../utils/index.js';
import { useMenuStore } from '../../store';
import { DEFAULT_ACCEPT_LIST, DEFAULT_IMAGE_PREFIX, DEFAULT_MAX_FILE_SIZE, MESSAGE_DURATION, DEFAULT_MESSAGES, REGEX } from '../../const/constants.js';

const URL_EXP = REGEX.URL;

const FileToBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
};

function getFileType(url, acceptList, uploadExtList = []) {
  let fileList = uploadExtList.concat(acceptList);
  let acList = fileList.filter((i) => { return url.indexOf(i) > -1 })
  //获取文件类型
  return acList.length > 0 ? acList[acList.length - 1] : ''
}


export default ({ onSuccess, cRef }) => {
  // 从 store 获取当前菜单配置
  const currentMenu = useMenuStore(state => state.currentMenu);
  
  // 从 currentMenu 获取配置，设置默认值
  const acceptList = currentMenu?.acceptList || DEFAULT_ACCEPT_LIST;
  const prefix = currentMenu?.prefix || DEFAULT_IMAGE_PREFIX;
  const maxLength = currentMenu?.maxLength || DEFAULT_MAX_FILE_SIZE;

  useImperativeHandle(cRef, () => ({
    onUpload: () => {
      clickBtn?.current.click()
    }
  }));
  const [imgUrl, setImgUrl] = useState('');
  const clickBtn = useRef();

  const showErrorMsg = (msg) => {
        MessagePlugin.error({
        content:msg,
        duration: MESSAGE_DURATION,
        className:'ocrDemo-messgae-error',
        icon:<span className="ocrDemo-icon-errorMsg"></span>
      })
  }

  const beforeUpload = (file) => {
    return new Promise(async (_, reject) => {
      isLogin();
      const imageBase64 = await FileToBase64(file);
      if (!file) {
        showErrorMsg('请选择文件')
        return reject()
      };
      const ext = file.name.split('.').pop().toLowerCase();
      if (!acceptList.includes(ext)) {
        showErrorMsg(currentMenu?.uploadExtErrorMsg ? <>体验页面不支持{ext}格式，请点击<a style={{ color: '#4A70FF' }} target="_blank" href={currentMenu.url}>{currentMenu.title}</a>调用API接口</> : DEFAULT_MESSAGES.INVALID_FILE_FORMAT)
        return reject()
      }
      if (imageBase64?.length > maxLength * 1024 * 1024) {
        showErrorMsg(`${DEFAULT_MESSAGES.FILE_TOO_LARGE_BASE641}${maxLength}M${DEFAULT_MESSAGES.FILE_TOO_LARGE_BASE642}`)
        return reject()
      }
      let _url = imageBase64;
      if (prefix === 'OfdFile') {
        _url = imageBase64.replace('data:application/octet-stream;base64,', '')
      } else if (ext === 'bmp') {
        _url = imageBase64.replace('data:image/bmp;base64,', '')
      } else if (['docx', 'doc', 'xlsx', 'xls', 'pptx', 'ppt', 'md', 'txt', 'pdf'].includes(ext)) {
        _url = imageBase64.replace(/data.+?;base64,/, '')
      }


      onSuccess && onSuccess({
        img: {
          type: 'base64',
          previewUrl: imageBase64,
          OriginUrl: _url,
          url: _url,
          base64prefix: '',
          prefix: `${prefix}Base64`,
          isExample: false,
          pageNum: 1,
          fileType: ext,
          cantPreview: false,
        },
        type: ext,
      });
      return reject()
    })
  };

  const handleStart = () => {
    // 上传开始
  };

  const handleSuccess = () => {
    // 上传成功
  };

  const handleError = () => {
    // 上传失败
  };

  const handleCheckBefore = () => {
    let ext = getFileType(imgUrl, acceptList, currentMenu?.uploadExtList);
    if (!URL_EXP.test(imgUrl)) {
      showErrorMsg(DEFAULT_MESSAGES.INVALID_URL)
    } else if (acceptList.filter((i) => { return ext === (i).toLowerCase() }).length <= 0) {
      showErrorMsg(currentMenu?.uploadExtErrorMsg ? <>体验页面不支持{ext}格式，请点击<a style={{ color: '#4A70FF' }} target="_blank" href={currentMenu.url}>{currentMenu.title}</a>调用API接口</> : DEFAULT_MESSAGES.INVALID_FILE_FORMAT)
    } else {
      onSuccess && onSuccess({
        img: {
          type: 'url',
          url: imgUrl,
          OriginUrl: imgUrl,
          prefix: `${prefix}Url`,
          fileType: ext,
          pageNum: 1,
          isExample: false,
          cantPreview: false,
        },
        type: ext,
      });
      setImgUrl('');
    }
  }

  return (
    <div className="ocr_upload__container">
      <div className="ocr_upload__width"
      >
        <Upload
          beforeUpload={beforeUpload}
          onStart={handleStart}
          onSuccess={handleSuccess}
          onError={handleError}
        >
          <Tooltip content={`支持${acceptList.join('、')}等格式，大小不超过${maxLength}M`} theme="light">
            <Button
              type="button"
              variant="base"
              ref={clickBtn}
              onClick={async (event) => {
                await isLogin(event);
              }}
              // type="hole"
              width="full"
            >
              上传本地文件
            </Button>
          </Tooltip>
        </Upload>
        <div className="unv-upload__btn-extra">
          <span className="unv-upload__btn-extra__tips">
            或
          </span>
          <Input
            prefixIcon={<span className="ocrDemo-icon_search" onClick={handleCheckBefore}></span>}
            suffixIcon={<span className="ocrDemo-icon_enter" onClick={handleCheckBefore}></span>}
            style={{ width: "100%" }}
            value={imgUrl}
            onEnter={handleCheckBefore}
            onChange={(e) => { setImgUrl(e) }}
            placeholder={`输入在线URL,回车发起调用，支持${acceptList.join('、')}等格式，大小不超过${maxLength}M`} />
        </div>
      </div>
      {
        currentMenu?.uploadErrorMsg && <div className="ocrDemo_upload__des">{currentMenu.uploadErrorMsg}</div>
      }
      
    </div>

  );
};